import { usePage, useWebsiteSettings } from 'publisher/store'
import { AlignType } from 'common/types/styleTypes'
import { getWebsiteStylesTypographyHeading } from 'src/publisher/store/website-settings/website-settings-selector'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'
import pageSelectors from 'publisher/store/page/pageSelectors'

export const useCalculateHeadingTextAlign = ({
  textAlign,
  mobileTextAlign,
}: {
  textAlign?: AlignType
  mobileTextAlign?: AlignType
}) => {
  const {
    textAlign: websiteGlobalTextAlign,
    mobileTextAlign: websiteGlobalMobileTextAlign,
  } = useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}
  const pageGlobalHeadingTextAlign = usePage(
    pageSelectors.getGlobalHeadingAlign,
  )
  const pageGlobalMobileHeadingTextAlign = usePage(
    pageSelectors.getGlobalMobileHeadingAlign,
  )

  const globalTextAlign = websiteGlobalTextAlign || pageGlobalHeadingTextAlign
  const globalMobileTextAlign =
    websiteGlobalMobileTextAlign || pageGlobalMobileHeadingTextAlign
  return {
    calculatedTextAlign: getCalculatedProperty({
      desktopProperty: textAlign,
      mobileProperty: mobileTextAlign,
      globalDesktopProperty: globalTextAlign,
      //TODO https://systeme-team.slack.com/archives/C020MV26SBH/p1754505782538659
      globalMobileProperty: textAlign || globalMobileTextAlign,
    }) as { mobile: AlignType; desktop: AlignType },
    globalTextAlign,
    globalMobileTextAlign,
  }
}
